import { render, staticRenderFns } from "./statist.vue?vue&type=template&id=1f5e5841&scoped=true"
import script from "./statist.vue?vue&type=script&lang=js"
export * from "./statist.vue?vue&type=script&lang=js"
import style0 from "./statist.vue?vue&type=style&index=0&id=1f5e5841&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e5841",
  null
  
)

export default component.exports